module.exports = __webpack_public_path__ + "img/famous-1.46e38c49.png";